import React, { useState, useEffect } from 'react';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import './index.css'
import { getTicketHistoryList } from 'actions/buyer';
import { connect } from 'react-redux';
import Grow from '@mui/material/Grow';
import TextField from '@mui/material/TextField';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';

const EnhancedTableToolbar = (props) => {
    const [searchText, setSearchText] = useState('')
    const [hide, setHide] = useState(true)

    useEffect(() => {
        let data = {
            page: 1,
            perPage: 50,
            close: '1'
        }
        props.getTicketHistoryList({ data })
    }, [])

    const handleTextChange = (e) => {
        setSearchText(e.target.value)
    }

    const clearSearch = () => {
        setSearchText('')
        setHide(true)
        let data = {
            page: 1,
            perPage: 50,
            filter: '',
            searchText: '',
            close: '1'
        }
        props.getTicketHistoryList({ data })
    }

    const applySearch = () => {
        let data = {
            page: 1,
            perPage: 50,
            filter: '',
            searchText: searchText,
            close: '1'
        }
        props.getTicketHistoryList({ data })
    }

    const handleKeyPress = (e) => {
        if (e.keyCode === 13) {
            applySearch()
        }
    }

    const { identifier } = props;

    return (
        <Toolbar>
            {
                identifier === "ticketHistoryList" ?
                    <React.Fragment>
                        <div style={{ marginTop: "-10px", marginRight: "0px", marginLeft: "0px", width: "80%" }}>
                            <TextField
                                className='search'
                                autoFocus={true}
                                fullWidth={true}
                                hidden={hide}
                                value={searchText}
                                onChange={handleTextChange}
                                placeholder='Type Ticket number OR Order id'
                                onKeyUp={handleKeyPress}
                                variant='standard'
                            />
                        </div>
                        <Grow appear in={true} timeout={300}>
                            <div className='searchBox' style={{ marginTop: "-10px", marginRight: "0px", marginLeft: "auto" }}>
                                <IconButton className='clear'>
                                    {hide ? <SearchIcon onClick={() => { setHide(false) }} /> : <ClearIcon onClick={clearSearch} />}
                                </IconButton>
                            </div>
                        </Grow>
                    </React.Fragment>
                    :
                    null
            }
        </Toolbar>
    );
}

const mapStateToProps = ({ buyer }) => {
    const { ticketHistoryList } = buyer;
    return { ticketHistoryList }
};

export default connect(mapStateToProps, { getTicketHistoryList })(EnhancedTableToolbar);